import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 1C1.438 1 .5 1.875.5 8s.938 7 7.5 7 7.5-.875 7.5-7-.937-7-7.5-7M4 4.633v1.4h8v-1.4zM4 8.7h4V7.3H4z"
                fill="currentColor"
            />
        </g>
    </svg>
));
CardLinesFilledSize16Glyph.displayName = 'CardLinesFilledSize16Glyph';
